import { useCallback } from 'react'

import { useNotification } from '@/hooks'
import { trafficAreasUtils } from '@/utils'

import { useEditing } from '../../../../../../hooks/useEditing'
import { useTrafficProfile } from '../../../../hooks/useTrafficProfile'

import { useDeleteTrafficAreaModal } from '../../../../../../../../modals/DeleteTrafficAreaModal'

export function useActions(trafficArea: uui.domain.client.rm.TrafficRegion) {
  const toast = useNotification()
  const trafficProfile = useTrafficProfile()
  const { setEditTrafficArea } = useEditing('trafficArea')

  const { show: showDeleteTrafficAreaModal } = useDeleteTrafficAreaModal()

  const profileId = trafficProfile.id
  const areaId = trafficArea.id

  const onDelete = useCallback(() => {
    showDeleteTrafficAreaModal()
  }, [showDeleteTrafficAreaModal])

  const onEdit = useCallback(() => {
    setEditTrafficArea(areaId)
  }, [areaId, setEditTrafficArea])

  const onExport = useCallback(() => {
    try {
      trafficAreasUtils.exportAreasToKML([trafficArea], profileId)
    } catch (e) {
      toast.error(e.message)
    }
  }, [toast, trafficArea, profileId])

  return {
    onDelete,
    onEdit,
    onExport,
  }
}
